import axiosInstance from './axios';

export const companySettingsService = {
  getSettings: async () => {
    const response = await axiosInstance.get('/company-settings');
    return response.data;
  },

  updateSettings: async (settingsData) => {
    const response = await axiosInstance.put('/company-settings', settingsData);
    return response.data;
  },
};
